import { useStaticQuery, graphql } from 'gatsby';

const getProjectDataOferton = () => {
  const {
    strapiPageOferton: { sections },
  } = useStaticQuery(graphql`
    query MyQuery {
      strapiPageOferton {
        sections {
          background_images {
            url
            localFile {
              url
            }
          }
          extra_data {
            date
            link
          }
        }
      }
    }
  `);

  return { sections };
};

export default getProjectDataOferton;
